<template>
  <StepModel
    :ui="uiBaseStep"
    :name="STEP_NAMES.contactCodeVerification"
    ui-title="Contact Verification"
    ui-subtitle="Let’s verify your mobile number to make sure we can reach you"
    :ui-error-message="getOtpCodeErrorMessage()"
    ui-button-text="Confirm"
   
  >
 
   <!-- ui-secondary-button="Change phone"
    :ui-secondary-action="changePhoneAction" -->
    <FieldsetOtp
      ref="otpFieldset"
      title="Enter the code you received from us by SMS"
      :subtitle="otpSubtitle"
      :on-change="resetOtpService()"
      :resend-code="resendOtpCode"
    />
  </StepModel>
</template>


<script>
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
// Models
import StepModel from "@/lib/components/models/step";
import FieldsetOtp from "@/forms/components/shared/fieldsets/otp";

import FormComponentMixin from "@/lib/mixins/form-component-mixin";

import otpService from "@/forms/api/services/otp";
import otpServiceReferal from '@/forms/api/services/otp-referral';
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import resetService from "@/lib/helpers/reset-service";

import FIELD_NAMES from "@/forms/constants/field-names";

import { OTP_VALIDATE } from "@/forms/constants/services";

export default {
  name: "OtpStep",

  mixins: [FormComponentMixin],

  props: {
    title: {
      type: String,
      default: "Contact Verification"
    },
    subtitle: {
      type: String,
      default: "Let’s verify your mobile number to make sure we can reach you"
    },
    changePhoneAction: {
      type: Function,
      default: () => {}
    }
  },

  components: {
    StepModel,
    FieldsetOtp,
  },
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  computed: {
    otpSubtitle() {
      const { values } = this.$store.state.formData;
      const phone = getValueByFieldName(values, FIELD_NAMES.phoneNumber) || "";
      const prefix = phone.substring(0, 2);
      const suffix = phone.substring(2);
      return `We have sent it to +971-${prefix}-${suffix}`;
    }
  },

  methods: {
    getOtpCodeErrorMessage() {
      const { otpFieldset } = this.$refs;
      if (otpFieldset) {
        return otpFieldset.getErrorMessage;
      }
      return null;
    },

    async resendOtpCode() {
      const response = await otpServiceReferal.resendOtpCustomer();
      return !!response;
    },

    resetOtpService() {
      return () => resetService(OTP_VALIDATE);
    }
  }
};
</script>
